import classNames from "classnames";
import React from "react";
import { DividerNode } from "../../build/types";
import { BuilderComponentProps } from "../BuilderInterface";
import { DividerPatterns, DEFAULT_PATTERN } from "./patterns/DividerPatterns";
import "./style.scss";

const BuilderDivider: React.FC<BuilderComponentProps> = ({ node, builderProps }: BuilderComponentProps) => {
    const dividerNode = node as DividerNode;
    const { id, attr, isVertical, pattern = DEFAULT_PATTERN, patternStyle } = dividerNode;

    const { style, ...rest } = attr || {};
    const { height, width, ...restStyle } = style || {};

    const  parseDimension = (value: string | number | undefined): number => 
        typeof value === 'number' ? value : parseInt(String(value)) || 2;

    const numWidth = parseDimension(width);
    const numHeight = parseDimension(height);

    const dividerClasses = classNames("builder-divider", {
        [`${attr?.className}`]: !!attr?.className,
        "builder-hover": !!builderProps
    });

    if (builderProps) {
        const {
            selectedMenu,
            selectCallback,
            outlineCallback,
            onDragStart: builderDragStart,
            onDragEnd: builderDragEnd
        } = builderProps;

        return (
            <div
                id={id}
                {...rest}
                className={dividerClasses}
                style={{ ...restStyle, height, width }}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                onDragStart={e => builderDragStart?.(e, id)}
                onDragEnd={builderDragEnd}
                draggable={builderDragStart ? "true" : "false"}
            >
                {DividerPatterns[pattern]?.({
                    width: numWidth,
                    height: numHeight,
                    color: patternStyle?.color || "black",
                    gap: parseInt(patternStyle?.gap?.toString() || "5"),
                    isVertical
                })}
                {selectedMenu}
            </div>
        );
    }

    // Render mode
    return (
        <div
        id={id}
        {...rest}
        className={dividerClasses}
        style={{ ...restStyle, height, width }}
    >
        {DividerPatterns[pattern]?.({
            width: numWidth,
            height: numHeight,
            color: patternStyle?.color || "black",
            gap: parseInt(patternStyle?.gap?.toString() || "5"),
            isVertical
        })}
    </div>
    );
};

export default BuilderDivider;

